export enum QuantityCheckEnum {
  MANUAL = 'manual',
  BARCODE = 'barcode',
  SERIAL_NUMBER = 'serial_number',
}
